export default {
  root: {
    padding: '24px 20px 12px',
    textAlign: 'center',
    fontSize: 20,
    fontWeight: 600,
  },
};
